import { motion } from "framer-motion";
import { MessageCircle, Search, FileCheck, Key } from "lucide-react";
import { useT } from "@/lib/i18n";

export default function Process() {
  const { t } = useT();
  const steps = [
    { n: "01", icon: MessageCircle, t: "proc.s1.t", b: "proc.s1.b" },
    { n: "02", icon: Search, t: "proc.s2.t", b: "proc.s2.b" },
    { n: "03", icon: FileCheck, t: "proc.s3.t", b: "proc.s3.b" },
    { n: "04", icon: Key, t: "proc.s4.t", b: "proc.s4.b" },
  ];

  return (
    <section id="process" data-testid="process-section" className="relative py-24 md:py-32 bg-navy-800/40">
      <div className="absolute inset-x-0 top-0 divider-gold" />
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-2xl mb-16">
          <div className="text-xs tracking-[0.3em] text-gold uppercase mb-4">{t("proc.eyebrow")}</div>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-white leading-tight">
            {t("proc.title.1")}{" "}
            <span className="italic text-gold">{t("proc.title.2")}</span>
          </h2>
        </div>

        <div className="relative grid md:grid-cols-4 gap-6 md:gap-4">
          <div className="hidden md:block absolute top-[52px] left-[8%] right-[8%] h-px bg-gradient-to-r from-transparent via-gold/40 to-transparent" />

          {steps.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.12 }}
              data-testid={`process-step-${i + 1}`}
              className="relative"
            >
              <div className="flex flex-col items-start">
                <div className="relative z-10 h-[104px] w-[104px] flex items-center justify-center">
                  <div className="absolute inset-0 rounded-full bg-navy-900 border border-gold/40" />
                  <div className="absolute inset-2 rounded-full border border-gold/20" />
                  <s.icon className="relative h-8 w-8 text-gold" />
                </div>
                <div className="mt-6">
                  <div className="font-serif text-sm text-gold tracking-widest mb-1">
                    {t("proc.step")} {s.n}
                  </div>
                  <h3 className="font-serif text-2xl text-white mb-3 leading-snug">{t(s.t)}</h3>
                  <p className="text-sm text-slate-400 leading-relaxed max-w-xs">{t(s.b)}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
